module.exports = __webpack_public_path__ + "static/media/staff2.6f9bf477.png";